module.exports = __webpack_public_path__ + "b57ad653e39caef60310efbcd2bacad0.png";